import script from "./crud-common-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./crud-common-ly.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__